import type { PlottingContext } from "../types/options/PlottingContext"
import type { Distance, Pixel } from "../types/units/Units"

import { HorizontalAlign } from "../types/align/HorizontalAlign"
import { VerticalAlign } from "../types/align/VerticalAlign"

export const CreateContext = (
  context: PlottingContext
): Required<PlottingContext> => ({
  color_map: {},
  file_map: {},
  font_family: "Helvetica",
  font_size: 12 as Pixel,
  horizontal_align: HorizontalAlign.CENTER,
  image_resolution: 300 as Pixel,
  page_bleed: 0 as Distance,
  scale_bleed: 0 as Distance,

  scale_map: {},
  stroke_width: 1 as Distance,
  unit_to_px: 1,
  vertical_align: VerticalAlign.CENTER,
  ...context,
})
